<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-05-23 18:04:12
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-18 16:52:14
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/orderDetails/list/components/affiliationDialog/components/hintDialog/index.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
	<el-dialog title="同步样品协作" :visible.sync="visible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
		<div class="yx-color-text-primary font-h4-regular">
			共选中 <span class="yx-color-warning">{{ total }}</span> 个样品订单
		</div>
		<span slot="footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button @click="confirm" type="primary">确定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { batchSyncCooperate } from '@/api/sampleOrder';
export default {
	name: 'syncCollaborate',
	computed: {
		total({ list }) {
			return list.length;
		},
	},
	data() {
		return {
			visible: false,
			list: [],
		};
	},
	methods: {
		show(list = []) {
			this.list = list;
			this.visible = true;
		},
		async confirm() {
			const sample_sn_list = this.list.map(item => item.sample_sn);
			const { fail = [] } = await batchSyncCooperate({ sample_sn_list });
			if (fail.length) {
				this.$modal({
					title: '提示',
					contentTitle: `共有 ${fail.length} 条同步失败，无法发送协作申请原因详见单个样品订单`,
					size: 'small',
					btns: [
						{
							type: 'primary',
							text: '我知道了',
							key: 'confirm',
						},
					],
				}).then(res => {
					if (res.key == 'confirm') {
						res.done();
					} else {
						res.done();
					}
				});
			} else {
				this.$message.success('操作成功！');
			}
			this.$emit('refresh');
			this.handleClose();
		},
		handleClose() {
			this.visible = false;
		},
	},
};
</script>

<style lang="less" scoped></style>
